import {
  Directive,
  ElementRef,
  EventEmitter,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID
} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";

@Directive({
  selector: '[appViewport]',
  standalone: true
})
export class ViewportDirective implements OnInit, OnDestroy {
  @Output() inViewport: EventEmitter<boolean> = new EventEmitter();

  private observer!: IntersectionObserver;

  constructor(private el: ElementRef, private ngZone: NgZone, @Inject(PLATFORM_ID) private platformId: Object) {
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.ngZone.runOutsideAngular(() => {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            this.inViewport.emit(entry.isIntersecting)
          });
        }, {
          threshold: 0.1 // Adjust threshold as needed
        });

        this.observer.observe(this.el.nativeElement);
      });
    }
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
